export const BASE_URL = 'https://us-central1-grabidentity.cloudfunctions.net/api'
export const getSaveDataUrl = ()=> `${BASE_URL}/save-data`
export const getSaveIdUrl = ()=> `${BASE_URL}/save-id`
export const getImageDataUrl = ()=> `${BASE_URL}/save-image`
export const getProcessRequestUrl = (id: string)=> `${BASE_URL}/process-request?id=${id}`
export const getCheckRequestUrl = (id: string)=> `${BASE_URL}/check-request?id=${id}`
